module.exports = __webpack_public_path__ + "static/ac-transcripts.f31dfb04.png";